import WideDrawer from '../../../../../components/general/WideDrawer';
import {CreateBlacklistRuleContent} from './CreateBlacklistRuleContent';
import {Client} from "../../Client.ts";
import {BlacklistRulePreviewTransaction, Rule} from "./types.ts";
import { GlAccount } from '../../../../../hooks/useGLAccounts.ts';

interface CreateBlacklistRuleDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    selectedBusiness: Client | null;
    onSelectedBusinessChange: (business: Client | null) => void;
    initialBusinessId?: string | null;
    initialRelationName?: string | null;
    initialRelationIban?: string | null;
    initialAmount?: number | null;
    initialDescription?: string | null;
    initialGeneralLedgerAccountId?: string | null;
    clients: Client[];
    glAccounts: GlAccount[];
    glAccountsLoading: boolean;
    onPreview: (rules: Rule[], clientBusinessId: string | null | undefined) => Promise<BlacklistRulePreviewTransaction[]>;
    onCreateRule: (rules: Rule[], glAccount: GlAccount | null, vatCode: string | null, vatDirection: string | null) => Promise<void>;
}

export function CreateBlacklistRuleDrawer({
    isOpen,
    onClose,
    selectedBusiness,
    onSelectedBusinessChange,
    initialBusinessId = null,
    initialRelationName = null,
    initialRelationIban = null,
    initialAmount = null,
    initialDescription = null,
    initialGeneralLedgerAccountId = null,
    clients,
    glAccounts,
    glAccountsLoading,
    onPreview,
    onCreateRule,
}: CreateBlacklistRuleDrawerProps) {
    return (
        <WideDrawer
            open={isOpen}
            updateOpenState={(open) => {
                if (!open) {
                    onClose();
                }
            }}
            title="Maak een nieuwe automatisering aan"
            width="xl"
        >
            <CreateBlacklistRuleContent
                selectedBusiness={selectedBusiness}
                onSelectedBusinessChange={onSelectedBusinessChange}
                initialBusinessId={initialBusinessId}
                initialRelationName={initialRelationName}
                initialRelationIban={initialRelationIban}
                initialAmount={initialAmount}
                initialDescription={initialDescription}
                initialGeneralLedgerAccountId={initialGeneralLedgerAccountId}
                glAccounts={glAccounts}
                glAccountsLoading={glAccountsLoading}
                onClose={onClose}
                clients={clients}
                onPreview={onPreview}
                onCreateRule={onCreateRule} 
            />
        </WideDrawer>
    );
}

